// extracted by mini-css-extract-plugin
export default {"icon":"icon___2BtlZ","spin":"spin___3MWIz","rotating":"rotating___3Isui"};